import { Component, OnInit } from '@angular/core';
import { TUI_VALIDATION_ERRORS, TuiFileLike } from '@taiga-ui/kit';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Observable, Subject, finalize, map, of, switchMap, timer } from 'rxjs';
import { MailService } from '../mail.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SuccessConfirmComponent } from '../success-confirm/success-confirm.component';
import { ErrorConfirmComponent } from '../error-confirm/error-confirm.component';

@Component({
  selector: 'app-form-educatore',
  templateUrl: './form-educatore.component.html',
  styleUrls: ['./form-educatore.component.scss'],
  providers: [
    {
      provide: TUI_VALIDATION_ERRORS,
      useValue: {
        required: 'Campo obbligatorio',
        requiredTrue: 'Accetta i termini per proseguire',
        email: 'E-mail non valida'
      }
    }
  ]
})
export class FormEducatoreComponent implements OnInit {

  readonly mailwingId = "99cd59c3-6cf9-48b2-977b-73ace8aaacf3"
  form = new FormGroup({
    name: new FormControl<string | null>(null, [Validators.required]),
    surname: new FormControl<string | null>(null, [Validators.required]),
    email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
    telefono: new FormControl<string | null>(null, [Validators.required]),
    cv: new FormControl<File | null>(null, [Validators.required]),
    privacy: new FormControl<boolean | null>(null, [])

  })

 
  constructor(private recaptchaV3Service: ReCaptchaV3Service, private mailService: MailService, private modalService: NgbModal) { }

  ngOnInit(): void {

   
     
  }

  sendEmail() {
    this.recaptchaV3Service.execute('sendEmail').subscribe(token => {
      console.log(token)
      const formData = new FormData();

      formData.append("name", this.form.controls.name.value as string);
      formData.append("surname", this.form.controls.name.value as string);
      formData.append("email", this.form.controls.email.value as string);
      formData.append("phone", this.form.controls.telefono.value as string);
      formData.append("cv", this.form.controls.cv.value!, this.form.controls.cv.value!.name);
      formData.append("privacy", "true");
      formData.append("g-recaptcha", token);
      formData.append("mailwing_id", this.mailwingId);

      this.mailService.inviaMail(formData).subscribe({
        next: (resp) => {
          this.modalService.dismissAll()
          this.modalService.open(SuccessConfirmComponent, {
            size: 'lg',
            modalDialogClass: 'signup-modal',
            centered: true,
            
          });
          
          
        },
        error: (error) => {
          this.modalService.dismissAll()
          this.modalService.open(ErrorConfirmComponent, {
            size: 'lg',
            modalDialogClass: 'signup-modal',
            centered: true,
            
          });
        }
      })

    })
      
    
    
  }
  


  removeCV(){
    this.form.controls.cv.reset();
  }
 
}
